import React, { useState, useEffect } from "react";
import "../Assests/Scss/Results.scss";
import axios from "axios";
import InternetChecking from "../Reusablecomponents/Network";
// Below is for import the imgaes
import ThreeAssessments from "../Assests/Images/Badges/3Assessments.svg";
import SixAssessments from "../Assests/Images/Badges/6Assessments.svg";
import AllRounder from "../Assests/Images/Badges/AllRounder.svg";
import Excelent from "../Assests/Images/Badges/Excellent.svg";
import Goddone from "../Assests/Images/Badges/Goodone.svg";

import ResultsMaths from "../Assests/Images/ResultsMaths.png";
import ResultScience from "../Assests/Images/ResultScience.png";
import ResultsEnglish from "../Assests/Images/ResultsEnglish.png";
import ResultsBiology from "../Assests/Images/Bilogy.png";
import Hindi from "../Assests/Images/Results/Hindi.png";
import Telugu from "../Assests/Images/Results/Telugu.png";
import sad from "../Assests/Images/sad.png";
import Neutral from "../Assests/Images/Neutral.png";
import happy from "../Assests/Images/happy.png";
import happiest from "../Assests/Images/happiest.png";
import { useNavigate } from "react-router-dom";
import { RxCrossCircled } from "react-icons/rx";
import { useSelector } from "react-redux";
import Loading from "../Reusablecomponents/Loading";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import TotalScore from "../Assests/Images/Results/TotalScore.svg";
import { format } from "date-fns";
const Results = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
  const [Result, SetResult] = useState();
  const [Load, SetLoad] = useState(false);

  const fetchAssessmentScore = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Assessment/GetAssessmentScore?ContestCreationId=${AssessmentData.contestCreationID}&UserId=${items.userId}&AssessmentType=${AssessmentData.assessmentType}&SubjectName=${AssessmentData?.testType === "single" ? AssessmentData?.subject1Name : ""}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetResult(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const SubImage = (e) => {
    if (Result) {
      switch (e) {
        case "Mathematics":
          return ResultsMaths;
        case "English":
          return ResultsEnglish;
        case "Biology":
          return ResultsBiology;
        case "Hindi":
          return Hindi;
        case "Telugu":
          return Telugu;
        default:
          return ResultScience;
      }
    }
  };
  const scorecolor = () => {
    if (Result) {
      switch (true) {
        case Result?.[0]?.overallPercentage <= 30:
          return ["red", <WithTranslate name="Results.WorkHard" />, sad];
        case Result?.[0]?.overallPercentage >= 31 && Result?.[0]?.overallPercentage <= 50:
          return ["blue", <WithTranslate name="Results.Nicework" />, Neutral];
        case Result?.[0]?.overallPercentage >= 51 && Result?.[0]?.overallPercentage <= 80:
          return ["orange", <WithTranslate name="Results.Awesome" />, happy];
        case Result?.[0]?.overallPercentage > 80:
          return [
            "green",
            <WithTranslate name="Results.Outstanding" />,
            happiest,
          ];
        default:
          return "";
      }
    }
  };
  useEffect(() => {
    fetchAssessmentScore();
  }, []);
  const BadgesImg = (Score) => {
    if (Result) {
      switch (true) {
        case Score === 100:
          return ["All Rounder", AllRounder];
        case Score >= 80 && Score <= 99:
          return ["Excellent", Excelent];
        case Score >= 60 && Score <= 79:
          return ["Good one", Goddone];
        default:
          return "";
      }
    }
  };
  const SubjectColor = (sub) => {
    if (Result) {
      switch (sub) {
        case "Mathematics":
          return "#AD46FF";
        case "English":
          return "#FF8204";
        // case "Biology":
        //   return ResultsBiology;
        case "Hindi":
          return "#F85F8D";
        case "Telugu":
          return "#F85F8D";
        default:
          return "#01CEB8";
      }
    }
  }
  const Dateformat = (e) => {
    const [year, month,day ] = e?.split("-");
    const date = new Date(`${year}-${month}-${day}`);
    return format(date, "dd MMM yyyy");
  };
  const Sessionlogout = () => {
    if (navigator.onLine) {
      // sessionStorage.clear();
      // localStorage.clear();
      navigate(
        `${AssessmentData.assessmentType === 3 ? "/Samagra/LoPerformance" : "/LoPerformanceReport"}`,
        {
          state: {
            CCID: AssessmentData?.contestCreationID,
            TType: AssessmentData?.assessmentType,
            Grade: items?.grade,
            Subjects: AssessmentData?.subjects,
            Date: Dateformat(AssessmentData.examStartDateTime?.split("T")[0]),
            ATType: AssessmentData?.testType,
            ATypeName: AssessmentData?.assessmentTypeNo,
            SSubject: AssessmentData?.testType === "single" ? Result?.[0]?.subjectName.trim() : "",
          },
          replace: true,
        },
      );
      // window.location.reload();
    }
  };
  return (
    <>
      <div className="dflex flexd-column alignitems Instructions-pages">
        {/* Results-Maindiv dflex flexd-column */}
        <InternetChecking />

        <RxCrossCircled id="btn_LogoutClose" onClick={Sessionlogout} className="ResultsICon" />
        {Result && (<p style={{ color: scorecolor()[0], fontSize: "20px", fontWeight: "700" }}> {scorecolor()[1]} <img src={scorecolor()[2]} alt="Smile" /> </p>)}
        <span onClick={Sessionlogout} className="CPointer mb-3" style={{ color: "blue", textDecoration: "underline" }}> Click here to view results </span>
        <div style={{ position: "relative" }}>
          <div className={`${Result?.length === 2 ? "TwoSubject-Cards" : ""} Subject-Cards`}>
            {Result?.map((item, index) => (
              <div className="Card Card-Width" key={index}>
                <div className="Subject-tittle dflex alignitems JSBetween">
                  <div> <img src={SubImage(item.subjectName)} alt={item.subjectName} /> <b style={{ color: SubjectColor(item.subjectName) }}>{item.subjectName}</b> </div>
                  <div>{item.totalScore} / {AssessmentData?.allSubjectWeightage?.split(",")[index]}
                  </div>
                </div>

                <div className="RSubject-Details ">
                  <div> <span> Attempted </span> <span>:</span> <span> {item.attempted} </span></div>
                  <div> <span> Unattempted </span> <span>:</span> <span> {item.unattempted} </span></div>
                  <div> <span> Correct </span> <span>:</span> <span> {item.correctAnswers} </span></div>
                  <div> <span> Incorrect </span> <span>:</span> <span> {item.wrongAnswers} </span></div>
                </div>
              </div>
            ))}

          </div>

          <div className="NToatalScore">
            <div className="dflex flexd-column alignitems Sub-ToatalScore ">
              < img src={TotalScore} alt="Total Score" />
              <div> <span style={Result && { color: scorecolor()[0] }}> {Result?.[0]?.overallScore} </span> /{AssessmentData.weightage}</div>
              Over all score
            </div>
          </div>
        </div>



        <div>
          <img src={BadgesImg(Result?.[0]?.overallPercentage)?.[1]} alt={BadgesImg(Result?.[0]?.overallPercentage)?.[0]} />

          {Result?.[0]?.lastThreeAssessment === 1 && Result?.[0]?.lastSixAssessment === 0 && <img src={ThreeAssessments} alt="3 Assessments" />}
          {Result?.[0]?.lastSixAssessment === 1 && <img src={SixAssessments} alt="6 Assessments" />}
        </div>
      </div>
      {Load && <Loading />}
    </>
  );
};
export default Results;
